export default "__VITE_ASSET__DMXLxEOp__";